export const CONTENT_URL_ROUTE = '(?<contentCode>[a-z_0-9-]+)';
export const SKELETON_BLOCK_NUMBER = 4;
